export const initDataModalUK = state => state.initData.initDataModalUK;
export const initDataModalRU = state => state.initData.initDataModalRU;
export const initDataVidzhetyUK = state => state.initData.initDataVidzhetyUK;
export const initDataVidzhetyRU = state => state.initData.initDataVidzhetyRU;
export const initErrorUK = state => state.initData.initErrorUK;
export const initErrorRU = state => state.initData.initErrorRU;
export const initLoading = state => state.initData.loading;
